import * as actions from "../../../../../../redux/actions/flowsActions";

export const onAddBot = async (dispatch, axis, id, currentAddHandle) => {
  const newNodeId = Date.now().toString();

  const newNode = {
    id: newNodeId,
    type: "bot",
    data: { label: "Bot" },
    position: axis,
    allowJoinSide: "left",
    toJoinSide: "right",
    fieldData: [],
    userConnected: 0,
    isUser: false,
  };

  const edge = {
    id: Date.now(),
    source: id,
    // ...(currentAddHandle !== null && { sourceHandle: currentAddHandle }),
    target: newNodeId,
    style: {
      strokeWidth: 2.2,
      stroke: "#566e8a",
    },
    type: "smoothstep",
  };

  console.log("edge", edge);

  await dispatch({
    type: actions.CURRENT_NODE_ID,
    payload: { nodeId: newNodeId },
  });

  const nodePayload = {
    newNode,
    nodeId: id,
  };

  if (currentAddHandle) {
    (edge.sourceHandle = currentAddHandle),
      (nodePayload.handleType = currentAddHandle);
  }

  console.log(nodePayload);

  dispatch({ type: actions.ADD_NODE, payload: nodePayload });
  dispatch({ type: actions.ADD_EDGE, payload: edge });
  dispatch({ type: actions.OPEN_SIDEBAR_BOT });
};
